import Vue from 'vue'
import Vuex from 'vuex'
import { state } from 'fs';

Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        drawer: false,
        editAlert: false,
        editAlertDialog: false,
        linePointData: false,
    },
    mutations: {
        setDrawer(state, tmp){
            state.drawer = tmp
        },
        setEditAlert(state, tmp){
            state.editAlert = tmp
        },
        setEditAlertDialog(state, tmp){
            state.editAlertDialog = tmp
        },
        setLinePointData(state, tmp){
            state.linePointData = tmp
        }
    },
    getters: {
        drawer: state => state.drawer,
        editAlert: state => state.editAlert,
        editAlertDialog: state => state.editAlertDialog,
        linePointData: state => state.linePointData,
    }
})
